export default [
    {
        path: '/admin',
        name: 'admin-home',
        component: () => import('@/views/admin/index.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/benefits',
        name: 'admin-benefit-list',
        component: () => import('@/views/admin/benefits/benefit_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/benefits/edit/:id?',
        name: 'admin-benefit-form',
        props: true,
        component: () => import('@/views/admin/benefits/benefit_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/chat',
        name: 'admin-chat-channel-list',
        component: () => import('@/views/admin/chat/chat_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/chat/edit/:id?',
        name: 'admin-chat-channel-form',
        props: true,
        component: () => import('@/views/admin/chat/chat_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/events',
        name: 'admin-event-list',
        component: () => import('@/views/admin/events/event_list.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/events/edit/:id?',
        name: 'admin-event-form',
        props: true,
        component: () => import('@/views/admin/events/event_form.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/events/:id/enrollments',
        name: 'admin-event-enrollments',
        props: true,
        component: () => import('@/views/admin/events/event_enrollments.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/faq',
        name: 'admin-faq-list',
        component: () => import('@/views/admin/faq/faq_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/faq/edit/:id?',
        name: 'admin-faq-form',
        props: true,
        component: () => import('@/views/admin/faq/faq_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/news',
        name: 'admin-news-list',
        component: () => import('@/views/admin/news/news_list.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/news/edit/:id?',
        name: 'admin-news-form',
        props: true,
        component: () => import('@/views/admin/news/news_form.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/news/:newsId/replies/:pollId',
        name: 'admin-news-poll-replies',
        props: true,
        component: () => import('@/views/admin/news/news_poll_replies.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/pages',
        name: 'admin-page-list',
        component: () => import('@/views/admin/pages/page_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/pages/edit/:id?',
        name: 'admin-page-form',
        props: true,
        component: () => import('@/views/admin/pages/page_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/polls',
        name: 'admin-poll-list',
        component: () => import('@/views/admin/polls/poll_list.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/polls/edit/:id?',
        name: 'admin-poll-form',
        props: true,
        component: () => import('@/views/admin/polls/poll_form.vue'),
        meta: {
            layout: 'admin',
        }
    },
    {
        path: '/admin/polls/replies/:pollId',
        name: 'admin-poll-replies',
        props: true,
        component: () => import('@/views/admin/polls/poll_replies.vue'),
        meta: {
            layout: 'admin',
        }
    },
    {
        path: '/admin/resources',
        name: 'admin-resource-list',
        component: () => import('@/views/admin/resources/resource_list.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/resources/edit/:id?',
        name: 'admin-resource-form',
        props: true,
        component: () => import('@/views/admin/resources/resource_form.vue'),
        meta: {
            layout: 'admin',
        },
    },

    {
        path: '/admin/feedback',
        name: 'admin-feedback-list',
        component: () => import('@/views/admin/feedback/feedback_list.vue'),
        meta: {
            layout: 'admin'
        },
    },
    {
        path: '/admin/feedback/:id',
        name: 'admin-feedback-form',
        props: true,
        component: () => import('@/views/admin/feedback/feedback_form.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/users',
        name: 'admin-user-list',
        component: () => import('@/views/admin/users/user_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/users/edit/:id?',
        name: 'admin-user-form',
        props: true,
        component: () => import('@/views/admin/users/user_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/settings/',
        name: 'admin-settings',
        props: true,
        component: () => import('@/views/admin/settings/settings.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/piiri-import/',
        name: 'admin-import',
        props: true,
        component: () => import('@/views/admin/import/import.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/changelog/',
        name: 'admin-changelog',
        props: true,
        component: () => import('@/views/admin/changelog/changelog.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
];